import React from "react";
import { MessageCircle } from "lucide-react";

const WA_LINK = "https://wa.me/351931777823?text=Hello%21%20I%20would%20like%20information%20about%20Porto%20Beyond%20the%20Postcard.";

export default function FloatingWhatsapp() {
  return (
    <a
      data-testid="floating-whatsapp"
      href={WA_LINK}
      target="_blank" rel="noreferrer"
      className="fixed bottom-24 right-6 z-[60] w-14 h-14 rounded-full bg-[#D8B07A] text-[#FDFAF3] flex items-center justify-center shadow-[0_20px_40px_-10px_rgba(50,60,40,0.4)] hover:scale-110 hover:bg-[#B89865] transition-all"
      aria-label="Chat on WhatsApp"
    >
      <MessageCircle size={22} strokeWidth={1.6} />
    </a>
  );
}
